export function OutlineFolder2Icon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9958 9.99981V8.9202C18.9958 7.85978 18.137 7.00088 17.0765 7.00088H9.99907V6.91931C9.99907 5.85889 9.14018 5 8.07976 5H4.92249C3.86207 5 3.00317 5.85889 3.00317 6.91931V16.9957"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M6.9714 10H18.9047C20.3346 10 21.3423 11.2811 20.8912 12.5239L19.0151 17.682C18.732 18.4642 17.9307 18.9968 17.0286 18.9968H5.09527C3.66539 18.9968 2.65775 17.7156 3.10878 16.4729L4.98491 11.3147C5.26801 10.5326 6.06932 10 6.9714 10Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
